import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  AIAS_REPORT_GET_JOB_LIST: createSagaAction('AIAS_REPORT_GET_JOB_LIST'),
  AIAS_REPORT_GET_ORGANIZATION_LIST: createSagaAction('AIAS_REPORT_GET_ORGANIZATION_LIST'),
  AIAS_REPORT_GET_FULL_REPORT: createSagaAction('AIAS_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  aiasReportGetJobList: ({ filters }) => ({
    type: constants.AIAS_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  aiasReportGetOrganizationList: ({ filters }) => ({
    type: constants.AIAS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    filters
  }),
  aiasReportGetFullReport: ({ filters }) => ({
    type: constants.AIAS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AIAS_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.AIAS_REPORT_GET_JOB_LIST.SUCCESS:
      return { ...state, error: null, loadingJobList: false, jobList: action.payload }

    case constants.AIAS_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.AIAS_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.AIAS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.AIAS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/financial/aiasReportActions.js